import { Routes, Route, Outlet, Navigate, Link } from "react-router-dom";
import Home from "./Pages/Home";
import Layout from "./Components/Common/Layout";
import Srp from "./Pages/Srp";
import Vdp from "./Pages/Vdp";
import OurService from "./Pages/OurService";
import AboutUs from "./Pages/AboutUs";
import ContactUs from "./Pages/ContactUs";
import Finance from "./Pages/Finance";
import Transportation from "./Pages/Transportation";
import SellYourCar from "./Pages/SellYourCar";
import AdminLayout from "./Components/Admin/AdminLayout";
import Dashboard from "./Components/Admin/Dashboard";
import Login from "./Components/Admin/Login";
import ManageVehicles from "./Components/Admin/ManageVehicles";
import ThankYou from "./Components/Common/ThankYou";
import { useContext, useState, useEffect } from "react";
import { UserContext } from "./Components/Context/UserContext";

const PrivateRoute = ({ user }) => {
    return user && user.username && user.username !== "publicuser" ? (
        <Outlet />
    ) : (
        <Navigate to="/login" replace />
    );
};

const PublicRoute = ({ user, children }) => {
    return user && user.username && user.username !== "publicuser" ? (
        <Navigate to="/admin/manage-vehicles" replace />
    ) : (
        children
    );
};
const AppRoutes = () => {
    const { user, loggedInCheck } = useContext(UserContext);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkLoginStatus = async () => {
            if (window.location.pathname.startsWith("/admin") || window.location.pathname === "/login") {
                await loggedInCheck();
            }
            setLoading(false);
        };
        checkLoginStatus();
    }, []);
    if (loading) {
        return <div>Loading...</div>;
    }
    return (
        <Routes>
            {/* <Route path="/" element={<Home />} /> */}
            <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path='/inventory' element={<Srp />} />
                <Route path='/vdp' element={<Vdp />} />
                <Route path='/our-service' element={<OurService />} />
                <Route path='/about-us' element={<AboutUs />} />
                <Route path='/contact-us' element={<ContactUs />} />
                <Route path='/finance' element={<Finance />} />
                <Route path='/transportation' element={<Transportation />} />
                <Route path='/sell-your-car' element={<SellYourCar />} />
                <Route path="/thank-you" element={<ThankYou />} />
            </Route>
            <Route
                path="/login"
                element={
                    <PublicRoute user={user}>
                        <Login />
                    </PublicRoute>
                }
            />
            {/* Private Routes */}
            {/* {checkedLogin &&  */}
            <Route element={<PrivateRoute user={user} />}>
                <Route element={<AdminLayout />}>
                    <Route path="/admin/manage-vehicles" element={<ManageVehicles />} />
                    
                    {/* Replace URL's */}
                    <Route path="/admin/*" element={<Navigate to="/admin/manage-vehicles" replace />} />
                    <Route path="/admin" element={<Navigate to="/admin/manage-vehicles" replace />} />
                </Route>
            </Route>
            {/* // } */}
            {/* {!checkedLogin && <>
                <Route path="/admin/manage-vehicles" element={<Login />} />
            </>} */}
            <Route path="*" element={<Navigate to="/inventory" replace />} />
        </Routes>
    );
};

export default AppRoutes;
